import { render, staticRenderFns } from "./DocumentVersionList.vue?vue&type=template&id=6dc0f6c0&"
import script from "./DocumentVersionList.vue?vue&type=script&lang=js&"
export * from "./DocumentVersionList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentVersionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports